import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { TrustedPlacesV2 as UITrustedPlacesV2 } from "@jti/loyalty/components/TrustedPlacesV2";

import type { trustedPlacesV2Inputs } from "./TrustedPlacesV2.builder";

type TrustedPlacesV2BuilderProps = BuilderComponentProps<typeof trustedPlacesV2Inputs>;

export const TrustedPlacesV2: FC<TrustedPlacesV2BuilderProps> = (props) => {
  return <UITrustedPlacesV2 {...props} isInEditor={isEditing()} />;
};
